<template>
  <div class="container">
    <div class="small" v-if="dataCollection && dataCollection.datasets.length">
      <line-chart :chartData="dataCollection" :options="options" />
    </div>
  </div>
</template>

<script>
import LineChart from './LineChart.js';
import { getRandomColor } from '@/utils/colors';

export default {
  props: {
    type: {
      type: String,
      default: 'line',
      validator: value => ['line'].includes(value),
    },
    data: Object,
  },
  components: {
    LineChart
  },
  data () {
    return {
      datacollection: null,
      borderColor: '',
      backgroundColor: '',
    }
  },
  computed: {
    dataCollection() {
      const { data_sets = [], labels = [] } = this.data;
      const datasets = data_sets.map(ds => ({
        label: ds.label,
        data: ds.data,
        borderColor: ds.border_color || getRandomColor(),
        backgroundColor: 'rgba(0, 0, 0, 0)',
      }));
      return { labels, datasets };
    },
    options() {
      const { y_axis_label, x_axis_label } = this.data;
      return {
        scales: {
          yAxes: [{ scaleLabel: { display: !!y_axis_label, labelString: y_axis_label } }],
          xAxes: [{ scaleLabel: { display: !!x_axis_label, labelString: x_axis_label } }],
        },
      };
    },
  },
}
</script>

<style scoped>
.container {
  width: 100%;
  height: 405px;
}

.small {
  margin: 0 auto;
  max-width: 1000px;
}
</style>